import { Component } from '@angular/core';
import { MachineService } from '../../services/machine.service';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { AdapterConnectionService } from 'src/app/services/adapter-connection.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-machine-modal',
  templateUrl: './machine-modal.component.html',
  styleUrls: ['./machine-modal.component.scss'],
})
export class MachineModalComponent {
  machineList = null;
  selectedMachine = null;
  selectedMachineId = null;

  selectedMachineSerial = null;
  selectedMachineMac = null;

  connectedMachine = null;

  adapterStatus = null;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private machineService: MachineService,
    private adapterService: AdapterConnectionService,
    public modalCtrl: ModalController,
    private log: NGXLogger
  ) {
    this.machineService
      .onGetMachines()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((machines) => {
        this.machineList = [...machines];
      });
  }

  dismiss() {
    this.modalCtrl.dismiss({
      selectedMachine: this.selectedMachine,
      selectedMachineId: this.selectedMachineId,
      connectedMachine: this.connectedMachine,
      adapterStatus: this.adapterStatus,
    });
  }

  onSelectMachine(machineId) {
    this.selectedMachine = this.machineService.getMachineById(machineId);
    this.selectedMachineId = this.selectedMachine.machineSettings.machineId;
    if (this.selectedMachine.pairedAdapter) {
      this.selectedMachineSerial = this.selectedMachine.pairedAdapter.serial;
      this.selectedMachineMac = this.selectedMachine.pairedAdapter.mac;
    }
    if (this.selectedMachineSerial && this.selectedMachineMac) {
      this.adapterService.connectToAdapter(this.selectedMachineSerial, this.selectedMachineMac, true);
      this.connectedMachine = true;
    }
    console.log(this.selectedMachineSerial);
    console.log(this.selectedMachineMac);
    this.dismiss();
  }

  onClickDisconnect() {
    this.selectedMachine = null;
    this.connectedMachine = null;
    this.adapterService.disconnect();
    this.dismiss();
  }

  ngOnDestoy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
